import React from "react";

const UpArrowIcon = () => {
  return (
    <svg
      width="20"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.264141 7.16621C0.433295 7.33411 0.662695 7.42843 0.901959 7.42843C1.14122 7.42843 1.37062 7.33411 1.53977 7.16621L6.00544 2.73305L10.4711 7.16621C10.6413 7.32935 10.8691 7.41962 11.1057 7.41758C11.3422 7.41554 11.5685 7.32135 11.7358 7.15531C11.903 6.98926 11.9979 6.76463 12 6.52981C12.002 6.29499 11.9111 6.06876 11.7468 5.89985L6.64327 0.833512C6.47409 0.665614 6.24467 0.57129 6.00544 0.57129C5.76622 0.57129 5.5368 0.665614 5.36762 0.833512L0.264141 5.89985C0.0949873 6.0678 0 6.29555 0 6.53303C0 6.77051 0.0949873 6.99827 0.264141 7.16621Z"
        fill="#666666"
      />
    </svg>
  );
};

export default UpArrowIcon;
